import React, { useState } from "react";
import { MdStickyNote2, MdExpandMore, MdExpandLess, MdChevronRight, MdOutlineMessage } from 'react-icons/md';

const Messages = ({ data }) => {
  const [open, setOpen] = useState(true);

  if (
    !data ||
    !data.driving_record ||
    !data.driving_record["messages"]
  ) {
    return (
      <div className="bg-white p-4 rounded-md shadow-sm border border-gray-200 text-center text-sm text-gray-500">
        Loading Messages...
      </div>
    );
  }

  const messages = data.driving_record["messages"];
  const messageArray = Array.isArray(messages) ? messages : [messages];

  return (
    <div className="bg-white rounded-xl shadow border border-gray-200 p-0 overflow-hidden">
      {/* Header */}
      <button
        className="flex items-center gap-2 w-full text-left px-4 py-3 bg-gray-50 border-b border-gray-100 hover:bg-gray-100 transition"
        onClick={() => setOpen((prev) => !prev)}
      >
        <MdOutlineMessage className="text-yellow-600 text-xl" />
        <span className="text-base font-semibold tracking-wide flex-1">State Messages</span>
        <span className="bg-blue-100 text-blue-700 text-xs font-bold px-2 py-0.5 rounded-full">{messageArray.length}</span>
        {open ? <MdExpandLess className="text-lg" /> : <MdExpandMore className="text-lg" />}
      </button>

      {/* Message List */}
      {open && (
        <div className="flex flex-col gap-1 px-4 py-3 bg-white">
          {messageArray.map((msg, idx) => (
            <div key={idx} className="flex items-start gap-2 text-[10px] leading-snug bg-gray-50 rounded px-2 py-1">
              <MdChevronRight className="text-blue-400 mt-[2px]" size={16} />
              <span className="whitespace-pre-line">{msg}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Messages;